import { QueryClient } from '@tanstack/react-query';
import { isAppError, isNonRetryable } from '@/lib/api/errors';

/**
 * QueryClient with Almanac-tuned defaults (plan §4.4 / §7).
 * - Don't retry client-fault errors (validation/forbidden/404/conflict).
 * - Retry transient server/network errors twice.
 * - Reasonable staleness; per-query overrides tune schemas/settings (long) vs lists (short).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => {
          if (isNonRetryable(error)) return false;
          // Never retry a 401 here — the client interceptor already handled refresh-retry.
          if (isAppError(error) && error.is('unauthorized')) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
